import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(13);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const Add = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 13 13" className={styles.icon}>
      <rect width="13" height="13" fill="#4C9C2E" />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="11"
        height="11"
      >
        <rect
          x="1.85714"
          y="1.85715"
          width="9.28571"
          height="9.28571"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#masked)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.37054 5.62947V1.85715H5.62947V5.62947H1.85714V7.37054H5.62946V11.1429H7.37054V7.37054H11.1429V5.62947H7.37054Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(Add);
